import React from 'react'
import { Box } from '@mui/material'//Se importan elementos de la librería material-ui

import { GenericDialog, FormDynamic } from '../../components'

export default function ConfigurationComponent(props) {

    let optionsNivelRiesgo = [{ Name: "Bajo", Value: "Bajo" }, { Name: "Medio", Value: "Medio" }, { Name: "Alto", Value: "Alto" }]
    let optionsRecFacial = [{ Name: "FaceTec3D", Value: "FaceTec3D" }, { Name: "FaceAI", Value: "FaceAI" }]

    const cuestionaryMetadata = [{ Id: "chkOmitirValidacion", Name: "Omitir validaciones", Required: true, Value: sessionStorage.getItem('omitirValidacion') ?? false, DataType: "CheckBox" },
    { Id: "cmbReconocimientoFacial", Name: "Motor reconocimiento facial", Required: true, Value: sessionStorage.getItem('TypeCaptureSelfieSdk') ?? "", DataType: "Combo", Options: optionsRecFacial },
    { Id: "cmbNivelRiesgo", Name: "Grado de riesgo", Required: true, Value: sessionStorage.getItem('nivelRiesgo') ?? "", DataType: "Combo", Options: optionsNivelRiesgo }]

    const handleConfirm = (formData) => {
        sessionStorage.setItem('omitirValidacion', formData["chkOmitirValidacion"])
        sessionStorage.setItem('nivelRiesgo', formData["cmbNivelRiesgo"])
        sessionStorage.setItem('TypeCaptureSelfieSdk', formData["cmbReconocimientoFacial"])
        props.close()
    }

    const handleCancel = (item) => {
        props.close()
    };

    return (<GenericDialog open={props.open} onClose={props.close}
        title="Configuración"
        content={<Box sx={{
            display: 'flex',
            position: 'relative',
        }}>
            {cuestionaryMetadata?.length > 0 ?
                <FormDynamic DataControls={cuestionaryMetadata}
                    handleConfirm={handleConfirm}
                    ConfirmButtonText={"Guardar"}
                    handleCancel={handleCancel} />
                : null}
        </Box>}
    />)
}